import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { services } from '../data/services';
import PageSEO from '../components/PageSEO';

export default function Services() {
  const [filter, setFilter] = useState('all');
  const filtered = filter === 'all' ? services : services.filter((s) => s.category === filter);

  return (
    <>
      <PageSEO
        title="Nos Prestations — Rénovation Indre & Berry"
        path="/services"
        description="Rénovation intérieure, cuisine, salle de bain, isolation thermique, toiture, façade et locaux commerciaux dans l'Indre (36) et le Cher (18). Garantie décennale. Devis gratuit."
      />
      <section className="bg-slate-900 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-sm text-slate-400 mb-4 flex items-center gap-2">
            <Link to="/" className="hover:text-orange-400">Accueil</Link>
            <span>/</span>
            <span className="text-white">Nos Prestations</span>
          </div>
          <h1 className="text-4xl font-extrabold text-white mb-3">Nos Prestations</h1>
          <p className="text-slate-400 text-lg max-w-2xl">
            Du ravalement de façade à la rénovation de cuisine, Apex Rénovation prend en charge tous vos travaux en Indre et alentours.
          </p>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-3 mb-10 flex-wrap">
            {[['all', 'Toutes'], ['residential', 'Résidentiel'], ['commercial', 'Commercial']].map(([val, label]) => (
              <button
                key={val}
                onClick={() => setFilter(val)}
                className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors ${filter === val ? 'bg-orange-600 text-white' : 'bg-white text-slate-700 border border-slate-200 hover:border-orange-300'}`}
              >
                {label}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((s) => (
              <div key={s.slug} className="bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-md transition-shadow group">
                <div className="h-48 overflow-hidden">
                  <img src={s.image} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="text-3xl">{s.icon}</span>
                    <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${s.category === 'residential' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`}>
                      {s.category === 'residential' ? 'Résidentiel' : 'Commercial'}
                    </span>
                  </div>
                  <h3 className="font-bold text-slate-900 text-xl mb-2">{s.name}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed mb-4">{s.shortDesc}</p>
                  <div className="flex flex-wrap gap-2 mb-5">
                    {s.tags.map((t) => <span key={t} className="bg-slate-100 text-slate-600 text-xs px-2.5 py-1 rounded-full">{t}</span>)}
                  </div>
                  <div className="flex items-center justify-between border-t border-slate-100 pt-4">
                    <div>
                      <p className="text-xs text-slate-400">Tarif</p>
                      <p className="font-bold text-slate-900 text-sm">À partir de {s.price}€</p>
                    </div>
                    <Link to={`/services/${s.slug}`} className="bg-orange-600 hover:bg-orange-700 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors">
                      En savoir plus
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-orange-600">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold text-white mb-4">Vous ne trouvez pas votre prestation ?</h2>
          <p className="text-orange-100 mb-8">Contactez-nous — nous étudions tous vos projets de rénovation, même les plus spécifiques.</p>
          <Link to="/devis" className="bg-white text-orange-600 font-bold px-8 py-4 rounded-lg hover:bg-orange-50 transition-colors inline-block">
            Demander un devis sur mesure
          </Link>
        </div>
      </section>
    </>
  );
}
